var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._l(_vm.modules, function (config, i) {
    return _c('div', {
      key: 10 + i
    }, [!config.submenu ? _c('v-list-item', {
      staticClass: "v-list-item",
      attrs: {
        "to": '/modules/' + config.path
      }
    }, [_c('v-list-item-action', [_c('IconCustom', {
      attrs: {
        "name": config.icon
      }
    })], 1), _c('v-list-item-title', [_vm._v(_vm._s(config.name[_vm.$i18n.locale]))])], 1) : _c('v-list-group', {
      attrs: {
        "value": false,
        "no-action": ""
      },
      scopedSlots: _vm._u([{
        key: "prependIcon",
        fn: function fn() {
          return [_c('IconCustom', {
            attrs: {
              "name": config.icon
            }
          })];
        },
        proxy: true
      }, {
        key: "activator",
        fn: function fn() {
          return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(config.name[_vm.$i18n.locale]))])], 1)];
        },
        proxy: true
      }], null, true)
    }, _vm._l(config.submenu, function (item, idx) {
      return _c('v-list-item', {
        key: idx,
        staticClass: "v-list-item",
        attrs: {
          "to": "/modules/".concat(config.path, "/").concat(item.path)
        }
      }, [_c('v-list-item-title', [_vm._v(_vm._s(item.name[_vm.$i18n.locale]))])], 1);
    }), 1)], 1);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }